var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.712 23.011"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(-3563.637 -1029.798)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    x1: 11.949,
    y2: 17.45,
    transform: "translate(3577.62 1032.578)",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x2: 11.949,
    y2: 17.45,
    transform: "translate(3566.417 1032.578)",
    fill: "none",
    stroke: "#2a2a2a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
};
export default __webpack_public_path__ + "static/media/arrow_down.48444377.svg";
export { SvgComponent as ReactComponent };